<template>
    <div id="layout-body" :style="{ 'margin-top' : headerMargin ? '60px': '0'}">
        <router-view></router-view>
        <back-top></back-top>
    </div>
</template>

<script>
    import backTop from '@/components/back-top'
    import store from '@/store'
    export default {
        name: "layout-body",
        data(){
          return{
              minHeight: 600,
            //   headerMargin:store.state.common.headerMargin
          }
        },
        components: { backTop },
        mounted(){

        },
        computed: {
            headerMargin() {
                return this.$store.state.common.headerMargin
            }
        },
        watch: {
            headerMargin: {
                immediate: true,
                handler: (n, o) => {
                    // // let htmlBodyElement = document.querySelector('body');


                }
            }
        }
    }
</script>

<style scoped>
#layout-body{
    /* margin-top: 60px; */
    /* min-height: -moz-calc(100vh - 80px);
    min-height: -webkit-calc(100vh - 80px);
    min-height: calc(100vh - 80px); */
}
</style>
